import { Stack, Typography, TypographyProps } from "@mui/material";
import * as React from "react";

import CheckIcon from "@mui/icons-material/Check";
import PublishOutlinedIcon from "@mui/icons-material/PublishOutlined";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import { useTranslation } from "react-i18next";

export type TableCellProviderStatusProps = {
  data: {
    value?: "pending" | "manual-rejected" | "auto-rejected" | "accepted" | string;
  };
};

const TableCellProviderStatus: React.FC<TableCellProviderStatusProps> = (props) => {
  const { t } = useTranslation();
  const value = props.data.value;
  let color: TypographyProps["color"];
  let text = "";
  let icon;

  switch (value) {
    case "accepted":
      color = "success.main";
      icon = <CheckIcon fontSize="small" />;
      text = t("common:manualRejection");
      break;
    case "manual-rejected":
      color = "error.main";
      icon = <CloseOutlinedIcon fontSize="small" />;
      text = t("common:manualRejection");
      break;
    case "auto-rejected":
      color = "error.main";
      icon = <CloseOutlinedIcon fontSize="small" />;
      text = t("common:autoRejection");
      break;
    default:
      color = "info.main";
      icon = <PublishOutlinedIcon fontSize="small" />;
      text = t("common:pendingUpload");
      break;
  }

  return (
    <Stack direction="row" alignItems="center" spacing={0.5} color={color}>
      {icon}
      <Typography sx={{ color: color }}>{text}</Typography>
    </Stack>
  );
};

export default TableCellProviderStatus;
